import { Container, Text } from "@mike/crt";
import { Page } from "../components/Page";

export function AboutPage() {
  return (
    <Page>
      <Text fontSize={72} color="#90d0ff" marginBottom={40}>
        ABOUT ME
      </Text>

      <Container
        maxWidth={"40%"}
        flexDirection="column"
        gap={24}
        fontSize={18}
        lineHeight={1.6}
        color="rgba(144, 208, 255, 0.9)"
      >
        <Text>Hi! I am Mike!</Text>
        <Text>Thank you for visiting my website!</Text>

        <Text>Here are some things about me:</Text>
        <Text>
          &gt; I'm an energetic and passionate person that loves to have fun,
          meet new people, and love life.
        </Text>

        <Text>
          &gt; I have enormous pride for the silliest things (like this website
          and my cat Alfredo).
        </Text>

        <Text>
          &gt; I have spent a large portion of my life with computers and have
          loved every minute of it (except for the times I didn't).
        </Text>

        <Text>&gt; I love sandwiches.</Text>

        <Container marginTop={40}>
          <Text fontSize={14}>PRESS ESC TO GO BACK</Text>
        </Container>
      </Container>
    </Page>
  );
}
